export default "__VITE_ASSET__0fb79dcc__"